import React from 'react';
import styled from 'styled-components';
import { useObserver } from 'mobx-react-lite';

import useUser from 'src/hooks/use-user';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { TextButton } from 'src/components/core';
import { PinField } from 'shared/components';
import { Statuses } from 'src/components/loyalty/use-loyalty';
import { PinSuccessLayout } from 'src/components/loyalty/modal/components/pin-success-layout';

type PinProps = {
  onClose: () => void;
  status: Statuses;
  programName: string;
  processPin: (pin: string) => void;
  resendPin: () => Promise<void>;
};

export const Pin = ({ onClose, status, programName, processPin, resendPin }: PinProps): JSX.Element => {
  const User = useUser();
  const phone = useObserver(() => User.phone);
  const { dispensary } = useDispensary();
  const hasError = status === Statuses.incorrectPin;

  return (
    <PinSuccessLayout programName={programName} onClose={onClose} cancelLabel='Cancel'>
      <PinField onComplete={processPin} />
      {hasError && <Error>Invalid code, try again</Error>}
      <Content>
        Enter the code we sent to (***) *** - {phone.slice(-4)} to connect your {dispensary.name} {programName} account.
      </Content>
      <StyledTextButton onClick={resendPin}>Resend Code</StyledTextButton>
    </PinSuccessLayout>
  );
};

const Error = styled.div`
  color: ${({ theme }) => theme.colors.red[55]};
  font-weight: 600;
  margin: 24px 0 8px;
`;

const Content = styled.div`
  color: #646d72;
  margin: 24px 0 48px;
`;

const StyledTextButton = styled(TextButton)`
  font-weight: 600;
`;
